import { call, put, takeLatest, delay } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { request, isApiError } from '../../xhr';
import { requestEarningsCalculation, requestEarningsCalculationSuccess, requestEarningsCalculationError } from './actionCreators';
export function* sendCalculateEarningsRequest(dollarPrice, productType) {
    const params = {
        dollar_price: dollarPrice,
        product_type: productType
    };
    ddt.log('shared', 'fetching earnings calculation', params);
    return yield call(request, {
        method: 'post',
        url: `/user/calculate_earnings`,
        data: params
    }, ()=>({
            dollarPrice: '10',
            serviceFee: '1.2',
            serviceFeePercentage: '20',
            dollarEarnings: '8.8'
        }));
}
export function* handleRequestEarningsCalculation(action) {
    yield delay(1000); // + takeLatest = debounced
    const { dollarPrice , productType  } = action.payload;
    const result = yield sendCalculateEarningsRequest(dollarPrice, productType);
    if (!result || isApiError(result) || result.error) {
        yield put(requestEarningsCalculationError(result.error));
    } else {
        yield put(requestEarningsCalculationSuccess(result));
    }
}
export default function* saga() {
    yield takeLatest(requestEarningsCalculation, handleRequestEarningsCalculation);
}
